<template>
  <button class="floating-button">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "FloatingButton"
};
</script>

<style lang="scss" scoped>
.floating-button {
  position: fixed;
  bottom: calc(#{$footerHeight} + 1rem);
  right: 1rem;
  border-radius: 50%;
  border: none;
  background: black;
  color: white;
  font-size: 1rem;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0.7rem;

  &:hover {
    opacity: 0.7;
  }
}
</style>
